import type { ReactElement } from "react";

export function EyeSlashIcon(): ReactElement {
  return (
    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#eye-slash-clip)">
        <path
          opacity="0.4"
          d="M0.0781372 7.61563C-0.0249878 7.86251 -0.0249878 8.13751 0.0781372 8.38438C0.543762 9.50001 1.52189 11.125 2.98439 12.4813C4.45626 13.8469 6.47814 15 9.00314 15C10.1688 15 11.2281 14.7531 12.175 14.3563L10.1688 12.35C9.79689 12.45 9.40626 12.5031 9.00314 12.5031C6.51876 12.5031 4.50314 10.4875 4.50314 8.00313C4.50314 7.60001 4.55626 7.20938 4.65626 6.83751L2.16876 4.35001C1.15314 5.50001 0.450012 6.72188 0.0781372 7.61563Z"
          fill="currentColor"
        />
        <path
          d="M1.28126 -0.778131C0.987512 -1.07188 0.512512 -1.07188 0.221887 -0.778131C-0.0687376 -0.484381 -0.0718626 -0.00938112 0.218762 0.284369L16.7188 16.7844C17.0125 17.0781 17.4875 17.0781 17.7781 16.7844C18.0688 16.4906 18.0719 16.0156 17.7781 15.725L14.7656 12.7125C14.85 12.6375 14.9344 12.5625 15.0156 12.4875C16.4781 11.1281 17.4563 9.50624 17.9219 8.39062C18.025 8.14374 18.025 7.86874 17.9219 7.62187C17.4563 6.50624 16.4781 4.88124 15.0156 3.52499C13.5438 2.15937 11.5219 1.00624 8.99689 1.00624C7.22189 1.00624 5.69689 1.57499 4.43439 2.38749L1.28126 -0.778131ZM6.39064 4.33437C7.12501 3.80937 8.02814 3.49999 9.00001 3.49999C11.4844 3.49999 13.5 5.51562 13.5 7.99999C13.5 8.97187 13.1906 9.87187 12.6656 10.6094L11.5813 9.52499C11.8469 9.07812 11.9969 8.55624 11.9969 7.99999C11.9969 6.34374 10.6531 4.99999 8.99689 4.99999C8.44064 4.99999 7.91876 5.15312 7.47189 5.41562L6.38751 4.33124L6.39064 4.33437Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="eye-slash-clip">
          <rect width="18" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
